package devxertech.com.pages.dashboard.serviceAndTechSection

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.VerticalDivider
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import kotlinx.browser.window
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba

@Composable
fun ServicesSection(breakpoint: Breakpoint) {

    val sitePalette = ColorMode.current.toSitePalette()
    var services by remember { mutableStateOf(true) }


    Column (
        modifier = Modifier.fillMaxWidth()
            .backgroundColor(rgba(250, 250, 250, 1))
            .padding(top= 20.px, bottom = 40.px),
        horizontalAlignment = Alignment.CenterHorizontally
    ){
        SpanText(
            "SERVICES & TECHNOLOGIES",
            modifier = Modifier
                .margin(top = 40.px, bottom = 10.px)
                .fontSize(if(breakpoint > Breakpoint.MD)18.px else 15.px)
                .fontFamily(Constants.FONT_FAMILY)
                .color(sitePalette.commonSecondaryButtonColor.rgb)
        )
        Column (horizontalAlignment = Alignment.CenterHorizontally){
            Row(modifier = Modifier.display(DisplayStyle.Flex).flexWrap(FlexWrap.Wrap),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center) {
                SpanText(
                    "CUSTOMIZED SOLUTION ",
                    modifier = Modifier.margin(bottom = 20.px).fontSize(if (breakpoint > Breakpoint.MD) 35.px else 20.px)
                        .fontFamily(Constants.FONT_FAMILY)
                        .fontWeight(FontWeight.Bold)
                        .color(sitePalette.primary.rgb)
                )
                SpanText(
                    "FOR PROJECT NEEDS",
                    modifier = Modifier
                        .margin(bottom = 20.px).fontSize(if (breakpoint > Breakpoint.MD) 35.px else 20.px)
                        .fontFamily(Constants.FONT_FAMILY)
                        .fontWeight(FontWeight.Bold)
                        .color(sitePalette.commonSecondaryButtonColor.rgb)
                )
            }
        }
        Row(modifier = Modifier.margin(topBottom = 30.px)) {
            Box(modifier = Modifier.width(134.px).height(43.px)
                .backgroundColor (if (services) sitePalette.commonSecondaryButtonColor.rgb else Colors.Transparent )
                .border(
                    width = 1.px,
                    color = sitePalette.commonSecondaryButtonColor.rgb,
                    style = LineStyle.Solid)
                .borderRadius(0.px, 0.px, 0.px, 15.px)
                .cursor(Cursor.Pointer)
                .onClick {
                    services = true
                },
                contentAlignment = Alignment.Center) { SpanText("Services", modifier = Modifier.fontSize(16.px)
                .fontFamily(Constants.FONT_FAMILY).color(if (services) Colors.White else sitePalette.primary.rgb))  }

            Box(modifier = Modifier.width(134.px).height(43.px)
                .backgroundColor (if (services)  Colors.Transparent else sitePalette.commonSecondaryButtonColor.rgb )
                .border(
                    width = 1.px,
                    color = sitePalette.commonSecondaryButtonColor.rgb,
                    style = LineStyle.Solid)
                .cursor(Cursor.Pointer)
                .borderRadius(0.px, 0.px, 15.px, 0.px)
                .onClick {
                    services = false
                },
                contentAlignment = Alignment.Center) { SpanText("Technologies", modifier = Modifier.fontSize(16.px)
                .fontFamily(Constants.FONT_FAMILY).color(if (services) sitePalette.primary.rgb  else Colors.White ))  }

        }
        if (services){
            ServicesSectionBox()
        }

        else{
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .margin(topBottom = 30.px)
                    .padding(leftRight =  5.percent)
                    .display(DisplayStyle.Flex)
                    .flexWrap(FlexWrap.Wrap)
                ,
                horizontalArrangement = Arrangement.Center) {
                TechnologiesBox(
                    title = "Backend Technologies",
                    color = sitePalette.backendTech.rgb,
                    borderColor = rgba(200, 139, 209, 1),
                    srcImage1 = Res.Image.elixir_logo,
                    srcImage2 = Res.Image.nodeJs_tech,
                    srcImage3 = Res.Image.python_logo,
                    techName1 = "Php",
                    techName2 = "Rubi on Rails",
                    techName3 = "Golang",
                    techName4 = "JavaScript"
                )
                TechnologiesBox(
                    title = "Frontend Technologies",
                    color = sitePalette.frontendTech.rgb,
                    borderColor = rgba(141, 151, 207, 1),
                    srcImage1 = Res.Image.react_logo,
                    srcImage2 = Res.Image.angular_Logo,
                    srcImage3 = Res.Image.vueJs_Logo,
                    techName1 = "Flutter",
                    techName2 = "Expressjs",
                    techName3 = "Clojurescript",
                    techName4 = "Backbonejs"
                )
                TechnologiesBox(
                    title = "Database Technologies",
                    color = sitePalette.databaseTech.rgb,
                    borderColor = rgba(219, 159, 159, 1),
                    srcImage1 = Res.Image.postfressSQL_tech,
                    srcImage2 = Res.Image.mangoDB_tech,
                    srcImage3 = Res.Image.mySQL_logo,
                    techName1 = "Firebase",
                    techName2 = "Oracle",
                    techName3 = "SQL",
                    techName4 = "XQUERY"
                )
                if(window.screen.width < 1600){
                    TechnologiesBox(
                        title = "Mobile Technologies",
                        color = sitePalette.mobileTech.rgb,
                        borderColor = rgba(84, 190, 162, 1),
                        srcImage1 = Res.Image.swift_logo,
                        srcImage2 = Res.Image.kotlin_tech,
                        srcImage3 = Res.Image.cHesh_logo,
                        techName1 = "Objective C",
                        techName2 = "Flutter",
                        techName3 = "Android",
                        techName4 = "IOS"
                    )
                    TechnologiesBox(
                        title = "Blockchain Technologies",
                        color = sitePalette.blockChainTech.rgb,
                        borderColor = rgba(198, 157, 112, 1),
                        srcImage1 = Res.Image.blockchain_logo,
                        srcImage2 = Res.Image.ethereum_logo,
                        srcImage3 = Res.Image.corda_logo,
                        techName1 = "Canadian Mist",
                        techName2 = "Maker",
                        techName3 = "XRP",
                        techName4 = "Tether"
                    )
                    TechnologiesBox(
                        title = "DevOps Technologies",
                        color = sitePalette.devOpsTech.rgb,
                        borderColor = rgba(184, 217, 94, 1),
                        srcImage1 = Res.Image.docker_logo,
                        srcImage2 = Res.Image.ansible_logo,
                        srcImage3 = Res.Image.puppet_logo,
                        techName1 = "Maven",
                        techName2 = "Selenium",
                        techName3 = "Bamboo",
                        techName4Option = false
                    )
                }

            }
            if(window.screen.width > 1600) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .margin(topBottom = 30.px)
                        .padding(leftRight = 5.percent),
                    horizontalArrangement = Arrangement.Center){
                    TechnologiesBox(
                        title = "Mobile Technologies",
                        color = sitePalette.mobileTech.rgb,
                        borderColor = rgba(84, 190, 162, 1),
                        srcImage1 = Res.Image.swift_logo,
                        srcImage2 = Res.Image.kotlin_tech,
                        srcImage3 = Res.Image.cHesh_logo,
                        techName1 = "Objective C",
                        techName2 = "Flutter",
                        techName3 = "Android",
                        techName4 = "IOS"
                    )
                    TechnologiesBox(
                        title = "Blockchain Technologies",
                        color = sitePalette.blockChainTech.rgb,
                        borderColor = rgba(198, 157, 112, 1),
                        srcImage1 = Res.Image.blockchain_logo,
                        srcImage2 = Res.Image.ethereum_logo,
                        srcImage3 = Res.Image.corda_logo,
                        techName1 = "Canadian Mist",
                        techName2 = "Maker",
                        techName3 = "XRP",
                        techName4 = "Tether"
                    )
                    TechnologiesBox(
                        title = "DevOps Technologies",
                        color = sitePalette.devOpsTech.rgb,
                        borderColor = rgba(184, 217, 94, 1),
                        srcImage1 = Res.Image.docker_logo,
                        srcImage2 = Res.Image.ansible_logo,
                        srcImage3 = Res.Image.puppet_logo,
                        techName1 = "Maven",
                        techName2 = "Selenium",
                        techName3 = "Bamboo",
                        techName4Option = false
                    )

                }
            }
        }
    }
}

@Composable
fun ServicesNameBox(text: String, selected: Boolean = false, onClick: () -> Unit){
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    Box(modifier = Modifier
        .width(if(breakpoint == Breakpoint.LG) 165.px else 175.px)
        .height(58.px)
        .borderRadius(2.px, 25.px, 2.px, 25.px)
        .border(
            width = 1.px,
            color = if (selected) sitePalette.primary.rgb else sitePalette.commonSecondaryButtonColor.rgb,
            style = LineStyle.Solid)
        .boxShadow(blurRadius = if (selected) 4.px else 0.px, spreadRadius = 0.px,
            color = if (selected) Colors.LightGray else Colors.Transparent)
        .onClick {onClick() },
        contentAlignment = Alignment.Center) {
        SpanText(text, modifier = Modifier.fontFamily(Constants.FONT_FAMILY).fontSize(16.px)
            .color(sitePalette.commonSecondaryButtonColor.rgb).textAlign(TextAlign.Center).cursor(Cursor.Pointer))
    }
}


@Composable
fun TechnologiesBox(
    title: String,
    color: Color.Rgb,
    borderColor: CSSColorValue,
    srcImage1: String,
    srcImage2: String,
    srcImage3: String,
    techName1: String,
    techName2: String,
    techName3: String,
    techName4Option: Boolean = true,
    techName4: String= "",
){
    val sitePalette = ColorMode.current.toSitePalette()
    Column (modifier = Modifier.margin(topBottom = 20.px, leftRight = 10.px)){
        Box(
            modifier = Modifier
                .width(195.px)
                .height(38.px)
                .borderRadius(5.px)
                .backgroundColor(color)
                .zIndex(2)
                .align(Alignment.CenterHorizontally),
            contentAlignment = Alignment.Center
        ) {
            SpanText(title,
                modifier = Modifier.textAlign(TextAlign.Center).fontFamily(Constants.FONT_FAMILY)
                    .color(sitePalette.commonSecondaryButtonColor.rgb)
            )
        }
        Box(modifier = Modifier.width(if (window.screen.width <= 375 ) 300.px else 396.px).height(165.px).borderRadius(10.px).backgroundColor(sitePalette.modalBackgroundColor.rgb)
            .margin(top =(-12).px)
            .borderBottom(2.5.px, LineStyle.Solid, borderColor),
            contentAlignment = Alignment.Center) {
            Column(Modifier.fillMaxSize(),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center) {
                Row(modifier = Modifier.fillMaxWidth().padding(leftRight = if (window.screen.width <= 375 ) 0.percent else 5.percent).flexWrap(FlexWrap.Wrap),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.SpaceAround) {
                    Image(src = srcImage1, modifier = Modifier.width(100.px).height(38.px))
                    VerticalDivider(modifier = Modifier.backgroundColor(sitePalette.commonSecondaryButtonColor.rgb).width(1.px).height(15.px))
                    Image(src = srcImage2, modifier = Modifier.width(100.px).height(38.px))
                    VerticalDivider(modifier = Modifier.backgroundColor(sitePalette.commonSecondaryButtonColor.rgb).width(1.px).height(15.px))
                    Image(src = srcImage3, modifier = Modifier.width(79.px).height(38.px))
                }
                Row(modifier = Modifier.fillMaxWidth().padding(3.percent)
                    .flexWrap(FlexWrap.Wrap),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.SpaceEvenly) {
                    SpanText(techName1, modifier = Modifier.fontFamily(Constants.FONT_FAMILY)
                        .color(sitePalette.commonSecondaryButtonColor.rgb))
                    VerticalDivider(modifier = Modifier.backgroundColor(sitePalette.commonSecondaryButtonColor.rgb).width(1.px).height(15.px))
                    SpanText(techName2, modifier = Modifier.fontFamily(Constants.FONT_FAMILY)
                        .color(sitePalette.commonSecondaryButtonColor.rgb))
                    VerticalDivider(modifier = Modifier.backgroundColor(sitePalette.commonSecondaryButtonColor.rgb).width(1.px).height(15.px))
                    SpanText(techName3, modifier = Modifier.fontFamily(Constants.FONT_FAMILY)
                        .color(sitePalette.commonSecondaryButtonColor.rgb))
                    if (techName4Option){
                        VerticalDivider(modifier = Modifier.backgroundColor(sitePalette.commonSecondaryButtonColor.rgb).width(1.px).height(15.px))

                        SpanText(techName4, modifier = Modifier.fontFamily(Constants.FONT_FAMILY)
                            .color(sitePalette.commonSecondaryButtonColor.rgb))}

                }

            }
        }
    }
}


